module.exports = __webpack_public_path__ + "img/UVC81.eae68acb.png";